import { render, staticRenderFns } from "./CourseListDialog.vue?vue&type=template&id=db82c70c&scoped=true&"
import script from "./CourseListDialog.vue?vue&type=script&lang=js&"
export * from "./CourseListDialog.vue?vue&type=script&lang=js&"
import style0 from "./CourseListDialog.vue?vue&type=style&index=0&id=db82c70c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db82c70c",
  null
  
)

export default component.exports